import { addHeaderInterceptor as r } from "./add-header-interceptor-factory.js";
import { generateTraceId as t } from "@accor/customer-api/cloud";
const c = (e) => e.interceptors.request.use(r("x-traceid", t()));
export {
  c as default
};
//# sourceMappingURL=x-traceid-interceptor.js.map
